import { LineItemViewModel } from '~/lib/data-contract';
import { getImageTags } from './getImageTags';
import { ProductWithQuantity } from '../model';

export const lineItemViewModelMapper = (products: LineItemViewModel[]): ProductWithQuantity[] => {
    return products.map(({
            id,
            priceDetails,
            engrosColor,
            quantity,
            category,
            productId,
            brand,
            imageTags,
            productType,
            size,
            productColorId,
        }) => {

        return {
            id: productId,
            item_sku: id || null,
            name: `${brand} ${category} ${engrosColor}`,
            category,
            brand,
            variant: engrosColor,
            quantity: quantity,
            price: priceDetails?.googleDisplayPrice,
            dimension11: id,
            category_2: productType,
            category_3: category,
            size: size,
            variant_id: productColorId || '',
            ...getImageTags(imageTags),
        };
    });
};
